/* eslint-disable no-undef */
import { createRoot } from "react-dom/client";
import "./index.scss"; screenLeft
import { applyMiddleware, createStore } from "redux";
import { rootReducers } from "./redux/rootReducers";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
//import {transitions,positions, Provider as AlertProvider, types, } from "react-alert";
/* import AlertTemplate from "react-alert-template-basic"; */
import { composeWithDevTools } from "redux-devtools-extension";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { persistStore, persistReducer } from "redux-persist";
import { PersistGate } from 'redux-persist/integration/react';
import i18n from "./i18n";
import storage from "redux-persist/lib/storage"; // Default storage is local storage
import { I18nextProvider } from "react-i18next";

const persistConfig = {
  key: "root", // key to store the data in local storage
  storage, // the storage object to use (local storage in this case) ,
  whitelist: ['authReducer', "otpReducer", "getPaymentConfigReducer", "merchantReducer"/* ,"partnerThemeCrudOperationsReducer" */]
};

const persistedReducer = persistReducer(persistConfig, rootReducers);



const store = createStore(
  // rootReducers,
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk))
);



const persistor = persistStore(store, [{ manualPersist: true }]);
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}  >
    <PersistGate loading={null} persistor={persistor}>
      {/* <React.StrictMode> */}
      <BrowserRouter >
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </BrowserRouter>
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>

);


